import React from "react";
import IconCard from "./IconCard";
import CardCounter from "./CardCounter";

const CardContainer = ({ card, counter, isLoading }) => {
  return (
    <div className="flex flex-wrap py-3">
      {card.map((el, index) => (
        <div className="m-4 " key={index}>
          <IconCard card={el} isLoading={isLoading} />
        </div>
      ))}
      <div className="m-4">
        <CardCounter counter={counter} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default CardContainer;
